/**
 * General formatting utilities for consistent display across the application
 */

/**
 * Formats a number for display, removing unnecessary decimal places
 * Minimal 0 decimals, maximal 2 decimals
 * @param value - Number to format
 * @param decimals - Maximum decimal places (default: 2)
 * @returns Formatted number string or empty string if null/undefined
 */
export function formatNumber(value: number | undefined | null, decimals: number = 2): string {
    if (value === undefined || value === null) return ""

    // Format with specified decimals and remove trailing zeros
    const formatted = value.toFixed(decimals)

    // Remove .00 or trailing zeros after decimal point
    return formatted.replace(/\.?0+$/, "")
}

/**
 * Formats a percentage value for display
 * Minimal 0 decimals, maximal 2 decimals
 * @param value - Number to format as percentage
 * @param decimals - Maximum decimal places (default: 2)
 * @returns Formatted percentage string or empty string if null/undefined
 */
export function formatPercentage(value: number | undefined | null, decimals: number = 2): string {
    if (value === undefined || value === null) return ""

    return `${formatNumber(value, decimals)}%`
}
